var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShopifyDuoColour = function SvgShopifyDuoColour(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-85940565-9e8d-4414-a43f-43d9d7b17e4f",
    viewBox: "0 0 109.9 124.8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-1a44bbc9-0aa8-40df-b92a-5ad651851690"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.2,19c2.1-.7,4.2-1.4,6-1.9-1.5-4.7-3.8-8.7-7.4-9.1,.9,2.6,1.5,5.8,1.5,9.7v1.3Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7,5c-.6-.4-1.3-.7-2-.7-11.5,0-18.1,15.2-20.8,24.5,3.2-1,6.4-2,9.9-3.1,2.3-12.3,7.8-18.3,12.9-20.8Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1,88.2c0,2-1.5,4.8-5,4.8-5.4,0-11.8-5.6-11.8-5.6l-3.3,10.8s6.1,7.6,18.4,7.6,17.7-7.7,17.7-19.6-4.4-12.1-8.7-15.5H24.2c2.9,8.9,12.9,10.2,12.9,17.4Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2,62.3c0-1.2,.4-5.9,7.9-5.9s9.3,2.3,9.3,2.3l4.7-14.1s-3.2-1.9-9.5-1.8c-16.9,0-25.2,11.3-25.2,22.9s.3,3.7,.8,5.3h20.2c-4.1-3.2-8.1-5.4-8.1-8.6Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5,24.2c4.3-1.4,8.5-2.6,12.4-3.9v-.7c0-4.8-.7-8.3-1.6-10.8-3.8,1.7-8.4,6.2-10.8,15.4Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4,65.6c0-11.6,8.3-22.9,25.2-22.9,6.3,0,9.5,1.8,9.5,1.8l-4.7,14.1s-4.2-2.3-9.3-2.3c-7.5,0-7.9,4.8-7.9,5.9,0,3.1,4,5.4,8.1,8.6h29.6l2.7-56c-.7-.1-1.4,0-1.8,0,0,0-1.5,.4-3.7,1.2-2.3-6.5-6.1-12.4-13.1-12.4h-.7c-1.9-2.5-4.4-3.6-6.4-3.6-16.1,0-23.8,20.1-26.2,30.3-6.3,2-10.8,3.3-11.3,3.5-3.5,1.1-3.6,1.2-4,4.5-.2,1.1-2.1,16.3-4.2,32.5H24.2c-.5-1.5-.8-3.2-.8-5.3ZM67.2,17.1c-1.8,.5-3.9,1.2-6,1.9v-1.3c0-3.9-.5-7.2-1.5-9.7,3.6,.4,5.9,4.5,7.4,9.1Zm-10.3,2.5v.7c-4,1.2-8.1,2.5-12.4,3.9,2.4-9.2,7-13.7,10.8-15.4,1,2.5,1.6,6,1.6,10.8Zm-6.3-15.3c.7,0,1.5,.3,2,.7-5.2,2.4-10.7,8.5-12.9,20.8-3.4,1.1-6.7,2-9.9,3.1,2.6-9.4,9.2-24.5,20.8-24.5Z",
    fill: "#6679e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4,70.8c4.3,3.3,8.7,7.8,8.7,15.5,0,11.9-7.5,19.6-17.7,19.6s-18.4-7.6-18.4-7.6l3.3-10.8s6.4,5.6,11.8,5.6,5-2.8,5-4.8c0-7.2-10-8.5-12.9-17.4H5.3C2.7,90.4,0,111.4,0,111.4l71.1,13.3h.2s2.6-53.9,2.6-53.9h-29.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,70.8c3.4,22.8,6.7,45.5,6.7,45.6l-38.4,8.3h0s38.6-8.3,38.6-8.3c0,0-3.4-22.7-6.7-45.6h-.1Z",
    fill: "#0f1f2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1,22.6s9.6,.7,10,.7,1,.3,1.1,.9c0,.3,3.5,23.5,6.9,46.6h.1c-3.4-23-6.8-46.2-6.9-46.6-.3-.7-.8-1-1.2-1.1-.4,0-10-.7-10-.7,0,0-6.7-6.7-7.5-7.3-.3-.3-.7-.4-1-.4h0c.4,.2,.7,.3,1,.6,.8,.7,7.5,7.3,7.5,7.3Z",
    fill: "#0f1f2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,70.8c-3.4-23-6.8-46.2-6.9-46.6,0-.7-.7-.9-1.1-.9s-10-.7-10-.7c0,0-6.7-6.6-7.5-7.3-.3-.3-.6-.4-1-.5l-2.7,56h29.1Z",
    fill: "#5163af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,70.8h-29.1l-2.6,53.9,38.4-8.3c0,0-3.3-22.8-6.7-45.6Z",
    fill: "#fff"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShopifyDuoColour, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopify-duo-colour.6e7c8025.svg";
export { ForwardRef as ReactComponent };